import { FormattedMessage } from 'react-intl';

import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { LabelS } from '#src/atoms/typography/index.tsx';
import { glossary } from '#src/lib/glossary.ts';

import rotowire from './assets/rotowire.svg';

export const PoweredByRotowire = () => {
  return (
    <Horizontal gap={0.5} center>
      <LabelS as="p" color="var(--c-onBase-secondary)">
        <FormattedMessage {...glossary.poweredBy} />
      </LabelS>
      <img src={rotowire} alt="RotoWire" />
    </Horizontal>
  );
};
